module.exports = __webpack_public_path__ + "static/media/Tile Image - White Gold (1).eb1f58a5.jpg";